// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Res, setRes, TFunc, UI, uqStringify } from "tonva-react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FieldItem, FieldItemInt, FieldItemNum, FieldItemString, FieldItemId } from "tonva-react";
import { SysFeatureRemind } from "./JkCoupon";

/*--fields--*/
const fields = {
	id: {
		"name": "id",
		"type": "id",
		"isKey": false,
		"label": "Id"
	} as FieldItemId,
	begin: {
		"name": "begin",
		"isKey": false,
		"label": "Begin"
	} as undefined,
	end: {
		"name": "end",
		"isKey": false,
		"label": "End"
	} as undefined,
};
/*==fields==*/

const fieldArr: FieldItem[] = [
	fields.begin, fields.end, 
];

export const ui: UI = {
	label: "SysFeatureRemind",
	fieldArr,
	fields,
};

const resRaw: Res<any> = {
	$zh: {
	},
	$en: {
	}
};
const res: any = {};
setRes(res, resRaw);

export const t:TFunc = (str:string|JSX.Element): string|JSX.Element => {
	return res[str as string] ?? str;
}

export function render(item: SysFeatureRemind):JSX.Element {
	return <>{uqStringify(item)}</>;
};
